var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.485,3.515a12,12,0,1,0-16.97,16.97,12,12,0,1,0,16.97-16.97ZM19.52,19.52A10.635,10.635,0,0,1,4.48,4.48,10.635,10.635,0,1,1,19.52,19.52Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M139.7,129.126a.68.68,0,0,0-.965,0l-4.324,4.324-4.324-4.324a.682.682,0,0,0-.965.965l4.324,4.324-4.324,4.324a.685.685,0,0,0,.48,1.167.665.665,0,0,0,.48-.2l4.324-4.324,4.324,4.324a.686.686,0,0,0,.48.2.657.657,0,0,0,.48-.2.68.68,0,0,0,0-.965l-4.314-4.324,4.324-4.324A.68.68,0,0,0,139.7,129.126Z",
    transform: "translate(-122.415 -122.415)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.df0f9dad42caca3f6854f240e87b3a0b.svg";
export { ForwardRef as ReactComponent };